// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"66a70a8c","121":"d5bdc0d3","163":"2047336d","251":"a57c10ef","317":"f35607f0","420":"a327ad68","460":"649e2c7b","606":"8b58d67e","693":"53e9c6e9","734":"4bef67c7","767":"5b86f752","848":"12ae6b60","916":"31f873b7"}[chunkId] + ".chunk.js";
};